import { render } from "./PinControl.vue?vue&type=template&id=0cc3c0bf"
import script from "./PinControl.vue?vue&type=script&lang=js"
export * from "./PinControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__